import React from 'react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { AblEnforcement } from './abl-enforcement';
import { getAblEnforcementDialogStyle } from './css/styles';
import type {
  AblEnforcementDialogProps,
  AblEnforcementDialogState,
  AddressSelectionState,
} from './types';

export class UnthemedAblEnforcementDialog extends React.Component<AblEnforcementDialogProps, AblEnforcementDialogState> {
  constructor(props: AblEnforcementDialogProps) {
    super(props);
    this.state = {
      country: props.country,
      originalAddress: props.originalAddress,
      addressSuggestions: props.addressSuggestions,
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps: AblEnforcementDialogProps) {
    this.setState({
      country: nextProps.country,
      originalAddress: nextProps.originalAddress,
      addressSuggestions: nextProps.addressSuggestions,
    });
  }

  onAddressSelectionChange = (state: AddressSelectionState) => {
    this.setState({
      addressSelected: state.addressSelected,
    });
  };

  onApplyAction = () => this.props.onApplyAction(this.state.addressSelected);

  render() {
    const {
      i18n,
      id,
      classes,
    } = this.props;

    if (this.props.showDialog) {
      return (
        <div className="abl-enforcement-dialog-group">
          <div className={`abl-enforcement-dialog-background ${classes.dialogBackground}`}>
            <div className={`abl-enforcement-dialog ${classes.dialog}`}>
              <AblEnforcement
                id={id}
                i18n={i18n}
                country={this.state.country}
                originalAddress={this.state.originalAddress}
                addressSuggestions={this.state.addressSuggestions}
                onAddressSelectionChange={this.onAddressSelectionChange}
                onApplyAction={this.onApplyAction}
                onCancelAction={this.props.onCancelAction}
              />
            </div>
          </div>
        </div>
      );
    }

    return null;
  }
}

(UnthemedAblEnforcementDialog as typeof UnthemedAblEnforcementDialog & {
  defaultProps: Partial<AblEnforcementDialogProps>;
}).defaultProps = {
  addressSuggestions: [],
  originalAddress: {},
};

export const AblEnforcementDialog = withDefaultStyles(UnthemedAblEnforcementDialog, getAblEnforcementDialogStyle);
